import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TEMPLATES } from "@/components/teacher/ActivityFields";
import { MODES } from "@/modes";

const MODE_DEFAULTS = Object.fromEntries(Object.entries(MODES).map(([k, m]) => [k, m.label]));

const DEFAULTS = Object.fromEntries(Object.entries(TEMPLATES).map(([k, t]) => [k, { ...t }]));
let cache = null;
const subs = new Set();

const apply = (cat) => {
  cache = cat;
  Object.keys(MODE_DEFAULTS).forEach((k) => { MODES[k].label = cat.modes?.[k]?.label || MODE_DEFAULTS[k]; });
  Object.keys(TEMPLATES).forEach((k) => {
    const o = cat.templates?.[k] || {};
    TEMPLATES[k] = { ...DEFAULTS[k], label: o.label || DEFAULTS[k].label, desc: o.description || DEFAULTS[k].desc, locked: Boolean(o.locked) };
  });
  subs.forEach((f) => f(cat));
};

export const reloadCatalog = () => api.get("/catalog").then((r) => apply(r.data)).catch(() => {});
export const templateDefaults = DEFAULTS;

// Geliştiricinin mod/etkinlik türü adları, açıklamaları ve kilitleri.
export const useCatalog = () => {
  const [cat, setCat] = useState(cache || { modes: {}, templates: {} });
  useEffect(() => {
    subs.add(setCat);
    if (!cache) reloadCatalog();
    return () => { subs.delete(setCat); };
  }, []);
  return cat;
};
